import { call, put } from 'redux-saga/effects';
import serviceLocator, { SSAP_SVC } from '../../APIs/common/service-locator';
import { validateAddressFailure, validateAddressSuccess } from '../../actions/ssap/ssapActionCreators';
import { showModal } from '../../actions/common/actionCreators';
import { ssapModalTypes as MODAL_TYPES } from '../../constants/ssap/modals/ssapModalTypes';
import { executeCallbacks } from '../../utils/miscellaneous/executeCallbacks';

export function* validateAddressSaga({ address, callback, stateCode = undefined }) {
    try {
        const ssapService = yield call(serviceLocator, SSAP_SVC);
        const result = yield call([ssapService, ssapService.validateAddress], address);

        if(result) {
            const {
                exactMatch,
                input
            } = result;

            const filterDataSuggestions = data => {

                const { suggestions } = data;

                return stateCode ?
                    {
                        ...data,
                        suggestions: suggestions && suggestions.filter(s => s.state === stateCode)
                    } :
                    data;
            };

            if(input && !exactMatch) {
                yield put(
                    showModal({
                        modalType: MODAL_TYPES.VALIDATE_ADDRESS_MODAL,
                        modalData: {
                            data: filterDataSuggestions(result),
                            callback,
                            stateCode
                        }
                    })
                );
            } else {
                yield call(executeCallbacks, callback);
            }
        } else {
            yield call(executeCallbacks, callback);
        }
        yield put(validateAddressSuccess());
    } catch(e) {
        yield call(executeCallbacks, callback);
        yield put(validateAddressFailure());
    }
}
